/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigDisplayInfraRedControlToggle_ConfigFragmentDoc } from './ConfigDisplayInfraRedControlToggle.graphql';
import { ConfigDisplayKeyboardControlToggle_ConfigFragmentDoc } from './ConfigDisplayKeyboardControlToggle.graphql';
import { ConfigDisplayPortsControlToggle_ConfigFragmentDoc } from './ConfigDisplayPortsControlToggle.graphql';
export type ConfigDisplayLockingSection_ConfigFragment = { __typename: 'ConfigurationModel', id: string, infraRedControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null, keyboardControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null, portsControl?: { __typename: 'ConfigPortsControlState', reported: Types.ConfigPortsControlLockState, supportedValues: Array<Types.ConfigPortsControlLockState> } | null };

export const ConfigDisplayLockingSection_ConfigFragmentDoc = gql`
    fragment ConfigDisplayLockingSection_config on ConfigurationModel {
  id
  ...ConfigDisplayInfraRedControlToggle_config
  ...ConfigDisplayKeyboardControlToggle_config
  ...ConfigDisplayPortsControlToggle_config
}
    ${ConfigDisplayInfraRedControlToggle_ConfigFragmentDoc}
${ConfigDisplayKeyboardControlToggle_ConfigFragmentDoc}
${ConfigDisplayPortsControlToggle_ConfigFragmentDoc}`;